import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { ListAuthorities } from "../../../components/Admin/Authorities";
import "./Authorities.scss";
import { useLanguage } from "../../../contexts";

export function Authorities() {
  const [reload, setReload] = useState(false);
  const onReload = () => setReload((prev) => !prev);

  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const panes = [
    {
      menuItem: t("active_authorities"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListAuthorities authoritiesActive={true} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("inactive_authorities"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListAuthorities authoritiesActive={false} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div className="authorities-page" style={{ padding: "0 0 1.5rem" }}>
      <div className="authorities-page-header-wrapper">
        <div className="authorities-page-header">
          <span className="authorities-page-title">{t("authorities")}</span>
        </div>
      </div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
}
